export const globalRatings = {
  "globalRatings.rating.set": "globalRatings.rating.set",
  "globalRatings.version.set": "globalRatings.version.set",
  "globalRatings.version.delete": "globalRatings.version.delete",
  "globalRatings.list.delete": "globalRatings.list.delete",
  "globalRatings.versions.get": "globalRatings.versions.get",
  "globalRatings.ratings.get": "globalRatings.ratings.get",
  "globalRatings.ratingData.get": "globalRatings.ratingData.get",
  "globalRatings.fullReports.get": "globalRatings.fullReports.get",
  "globalRatings.ratingsListName.get": "globalRatings.ratingsListName.get",
} as const;
